import { NotificationDto } from 'api/activity-feed';

/**
 * Catégorie portée par les notifications d'affectation d'un lead partenaire
 * (émises par le back à la matérialisation, destinataire = courtier affecté).
 * Contrat à confirmer côté back — c'est le seul point d'accroche du popup d'accueil.
 */
export const LEAD_NOTIFICATION_CATEGORY = 'lead';

/**
 * `details` porte la checklist « à compléter avant devis » : les mêmes libellés
 * que le `fieldsToComplete` renvoyé au gestionnaire à la conversion. Le champ
 * existe sur toutes les notifications mais reste vide hors leads — d'où le bloc
 * affiché seulement si la liste est non vide.
 */
export type LeadNotificationDto = NotificationDto;

/** Une notification d'affectation de lead ? (comparaison insensible à la casse) */
export const isLeadNotification = (notification: NotificationDto): boolean =>
  (notification.category ?? '').toLowerCase() === LEAD_NOTIFICATION_CATEGORY;
